<script>
import { BreadcrumbItem } from 'element-ui';
const BreadcrumbItemWrapper = BreadcrumbItem;
BreadcrumbItemWrapper.name = 'JskBreadcrumbItem';
export default BreadcrumbItemWrapper;
</script>

<style lang="scss" src="../../theme/breadcrumb-item.scss"></style>
